var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from "styled-components";
import Icon from './IconBase';
function ChatCircularIcon(props) {
    if (!(props.width || props.height)) {
        props = Object.assign(__assign({}, props), { width: 21 });
    }
    return (React.createElement(Icon, __assign({ "data-icon": 'home', fill: "none", viewBox: "0 0 21 20" }, props),
        React.createElement("g", { id: "chat_selected", transform: "translate(2, 1)", fillRule: "nonzero" },
            React.createElement("path", { d: "M0.082,18 L9,18 C13.962,18 18,13.962 18,9 C18,4.038 13.962,0 9,0 C4.038,0 0,4.038 0,9 C0,10.924 0.622,12.802 1.77,14.35 L2.196,14.924 L1.792,15.513 L0.082,18 Z", id: "Path", stroke: "currentColor", strokeWidth: "2" }),
            React.createElement("circle", { id: "Oval", fill: "currentColor", cx: "11.5", cy: "7.5", r: "1.5" }),
            React.createElement("circle", { id: "Oval", fill: "currentColor", cx: "6.5", cy: "7.5", r: "1.5" }))));
}
export default styled(ChatCircularIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
